module.exports = __webpack_public_path__ + "img/w37b.a792f57c.jpg";